import { FormSubmitButton } from '@flatsy/core'
import i18n from '@flatsy/utils/translations'
import { AppBar } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import React from 'react'
import useStyles from './Styles'
import { ComponentsProps } from './Type'

const MobileButton: React.FC<ComponentsProps> = ({ handleBackNavigationMobile, disabled }) => {
  const classes = useStyles()
  return (
    <AppBar position="fixed" color="primary" className={classes.bottomNavigation}>
      {handleBackNavigationMobile ? (
        <a href="back" className={classes.back} onClick={handleBackNavigationMobile}>
          <ArrowBackIcon className={classes.backIcon} />
          <span>{i18n.t('back')}</span>
        </a>
      ) : (
        <div />
      )}
      <FormSubmitButton type="submit" disabled={disabled} className={classes.bottomButton}>
        {i18n.t('continue')}
      </FormSubmitButton>
    </AppBar>
  )
}

export default MobileButton
